import { useContextState } from '../../../../hooks/theme'

export const useStyles = () => {
  const { colors } = useContextState()

  return {
    container: {
      width: '100%',
      height: '100%',
      padding: '20px 50px 20px 10px',
      overflow: 'hidden',
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '30px',
    },
    headerLeft: {
      display: 'flex',
      flexDirection: 'column',
    },
    title: {
      fontSize: '22px',
      fontWeight: '600',
      color: colors.color9,
    },
    stepperContainer: {
      width: '40%',
    },
    stepsContent: {
      border: `1px solid ${colors.color23}`,
      borderRadius: '4px',
      padding: '14px 20px',
      flex: 1,
      minHeight: 0,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    footer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      paddingTop: '20px',
      marginTop: 'auto',
    },
    continueButton: {
      padding: '6px 17px',
      fontWeight: '500',
      borderRadius: '5px',
    },
  }
}
